module.exports = __webpack_public_path__ + "static/media/topImage.6952f780.png";